var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowUpRight = function SvgArrowUpRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 17.936 14.935 8 16 9.065 6.065 19 5 17.936Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.265 6.492H7V5h9.265A2.735 2.735 0 0 1 19 7.735V17h-1.492V7.735c0-.686-.557-1.243-1.243-1.243Z",
    fill: "currentColor"
  })));
};
export { SvgArrowUpRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01IDE3LjkzNTVMMTQuOTM1NSA4TDE2IDkuMDY0NTJMNi4wNjQ1MiAxOUw1IDE3LjkzNTVaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNi4yNjQ1IDYuNDkyMDhMNyA2LjQ5MjA4VjVMMTYuMjY0NSA1QzE3Ljc3NTMgNSAxOSA2LjIyNDcyIDE5IDcuNzM1NDhMMTkgMTdMMTcuNTA3OSAxN1Y3LjczNTQ4QzE3LjUwNzkgNy4wNDg3NyAxNi45NTEyIDYuNDkyMDggMTYuMjY0NSA2LjQ5MjA4WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";